import React from 'react';
import styled from 'styled-components/macro';
import { IconNotificationError } from '@snsw/react-component-library';

const FieldError = ({ message, marginBottom = '16px' }) => {
  const StyledError = styled.div`
    color: rgb(184, 18, 55);
    margin-top: 17.5px;
    display: flex;
    margin-bottom: ${marginBottom};

    svg {
      margin-right: 14px;
      margin-top: 3px;
    }

    div {
      flex: 1;
    }
  `;
  return (
    <StyledError>
      <IconNotificationError />
      <div>{message}</div>
    </StyledError>
  );
};

export default FieldError;
